import Vue from 'vue';
import Component from 'vue-class-component';
import {Emit, Model, Prop, Watch} from 'vue-property-decorator';

@Component({})
class EdRadioButton extends Vue {
  @Model('update:modelValue', {
    required: true,
    validator: (value: any) => {
      return (
        value === null ||
        typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean'
      );
    },
  })
  modelValue!: string | number | boolean | null;
  @Prop({type: String, default: ''})
  classContainerInput!: string;
  @Prop({type: String, default: ''})
  name!: string;
  @Prop({type: String, default: ''})
  title!: string;
  @Prop({type: [String, Number, Boolean], required: true})
  value!: string | number | boolean;
  @Prop({type: String})
  label!: string;
  @Prop({type: Boolean, default: false})
  disabled!: boolean;
  @Prop({type: Boolean, default: false})
  initialCheck!: boolean;
  @Prop({type: Boolean, default: false})
  noHover!: boolean;
  @Prop({type: String, default: ''})
  radioId!: string;
  @Prop({
    type: Number,
    default: 10,
    validator: (value: number) => value >= 0,
  })
  paddingY!: number;

  get isChecked() {
    return this.modelValue === this.value;
  }

  get computedStyles() {
    return {
      '--ed-color-radio-hover': this.colorRadioHover,
      '--ed-padding-vertical': `${this.paddingY}px`,
      '--ed-padding-container-input': this.paddingContainerInput,
    }
  }

  get colorRadioHover() {
    return this.noHover ? 'transparent' : this.isChecked ? '#daf0ee' : '#d3d3d3';
  }

  get paddingContainerInput() {
    return this.noHover ? this.label ? '2px 10px 2px 2px' : '0px' : '10px';
  }

  get internalValue() {
    return this.modelValue;
  }

  set internalValue(value: string | number | boolean | null) {
    this.$emit('update:modelValue', value);
  }

  @Emit('change')
  onChange() {
    return this.modelValue;
  }
}

export default Vue.component('ed-radio-button', EdRadioButton);